import {Props} from './model';
import {reduxForm} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import View from './view';
import React, {useRef, useState} from 'react';
import {useOnClickOutside} from '../../../../../shared/hooks/useOutsideClick';

const Form = reduxForm<any, any>({
  form: Forms.applicationsFilterForm,
  destroyOnUnmount: false,
})(View);

export const ApplicationsFilterDesktop = (props: Props) => {
  const [showFilter, setDisplayState] = useState(false);
  const wrapRef = useRef(null);

  useOnClickOutside(wrapRef, () => {
    setDisplayState(false);
  });

  return React.createElement(Form, {
    ...props,
    wrapRef,
    showFilter,
    toggleFilter: () => {
      setDisplayState(!showFilter);
    },
  });
};
